import { HTMLAttributes, ReactNode, forwardRef } from 'react'
import { TooltipAlertCircle } from '@/ui'

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode
  action?: ReactNode
  footer?: ReactNode
  children: ReactNode
  tooltip?: string
}

const DashboardCard = forwardRef<HTMLDivElement, Props>(function Button(
  { children, title, action, tooltip, ...rest },
  ref,
) {
  return (
    <section
      className="flex flex-col gap-3 rounded-md border border-border-secondary p-4 shadow-xs"
      ref={ref}
      {...rest}
    >
      {title || action ? (
        <div className="flex items-center justify-between gap-6">
          <div>
            {title && (
              <div
                className="inline-flex items-center justify-center gap-1 text-[16px] font-semibold text-text-secondary"
                data-testid="dashboard/chart-title"
              >
                {title}
                {tooltip && <TooltipAlertCircle message={tooltip} />}
              </div>
            )}
          </div>
          {action}
        </div>
      ) : null}
      {children}
    </section>
  )
})

export default DashboardCard
